import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/fmp.css';
import '../styles/Projetosdeskbee.css';

const ProjetosPlaceholder = ({ cliente_id }) => {
  const navigate = useNavigate();
  const [sistemaCliente, setSistemaCliente] = useState(null);

  // Descobre se o cliente é Omie ou Conta Azul para saber pra qual dashboard voltar
  useEffect(() => {
    if (!cliente_id) return;
    const token = localStorage.getItem('access');
    axios.get(
      `${process.env.REACT_APP_API_BASE}/api/cliente-bpo/${cliente_id}/`,
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then((response) => {
        if (response.data.success) {
          setSistemaCliente(response.data.cliente?.sistema || 'omie');
        }
      })
      .catch(() => {});
  }, [cliente_id]);

  const irParaDashboard = () => {
    if (sistemaCliente === 'conta_azul') {
      navigate(`/dashboard-conta-azul/${cliente_id}`);
    } else {
      navigate(`/dashboard-cliente/${cliente_id}`);
    }
  };

  return (
    <div className="container-fluid mt-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div
            className="card border-0 shadow-sm"
          >
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-project-diagram header-icon me-3"></i>
                    <h2 className="titulo-pagina m-0">Gestão de Projetos</h2>
                  </div>
                  <p className="mb-1 opacity-75">
                    <i className="fas fa-info-circle me-2"></i>
                    Módulo de controle e análise de projetos
                  </p>
                </div>
                
                <button 
                  className="btn btn-light"
                  onClick={irParaDashboard}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar ao Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Aviso de Módulo Não Liberado */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body py-5">
              <div className="text-center">
                <div className="mb-4">
                  <i className="fas fa-lock fa-5x" style={{color: '#ffc107'}}></i>
                </div>

                <h3 className="mb-3" style={{color: '#495057'}}>
                  <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                  Módulo Reservado
                </h3>

                <div className="alert alert-warning mx-auto" style={{maxWidth: '600px'}}>
                  <p className="mb-0" style={{fontSize: '1.1rem'}}>
                    <strong>Este módulo está reservado para desenvolvimento customizado.</strong>
                  </p>
                </div>

                <div className="mt-4">
                  <p className="text-muted mb-3">
                    O módulo de <strong>Gestão de Projetos</strong> será desenvolvido sob medida 
                    conforme as necessidades específicas do cliente.
                  </p>

                  {/* Bloco de contato removido em 16/10/2026: trazia o e-mail e o WhatsApp
                      pessoal da Fernanda, que não está mais na Comece. Fica sem contato até
                      definirem quem assume — de preferência um endereço da empresa
                      (contato@/comercial@), que não quebra quando alguém sai. */}
                  <p className="text-muted mb-0">
                    Fale com a equipe comercial da Comece para avaliar o escopo e o prazo.
                  </p>

                  <div className="mt-4">
                    <button
                      className="btn btn-outline-secondary btn-lg"
                      onClick={irParaDashboard}
                    >
                      <i className="fas fa-arrow-left me-2"></i>
                      Voltar ao Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card border-0 bg-light">
            <div className="card-body">
              <h6 className="text-muted mb-3">
                <i className="fas fa-info-circle me-2"></i>
                Funcionalidades que podem ser desenvolvidas no módulo de Projetos:
              </h6>
              <div className="row">
                <div className="col-md-3">
                  <small className="text-muted">
                    <i className="fas fa-check-circle text-success me-1"></i>
                    Controle de prazos e entregas
                  </small>
                </div>
                <div className="col-md-3">
                  <small className="text-muted">
                    <i className="fas fa-check-circle text-success me-1"></i>
                    Margem por produto ou serviço
                  </small>
                </div>
                <div className="col-md-3">
                  <small className="text-muted">
                    <i className="fas fa-check-circle text-success me-1"></i>
                    Análise financeira por projeto
                  </small>
                </div>
                <div className="col-md-3">
                  <small className="text-muted">
                    <i className="fas fa-check-circle text-success me-1"></i>
                    Previsões e relatórios customizados
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="row mt-4 mb-4">
        <div className="col-12">
          <div className="card border-0" style={{backgroundColor: '#00205b'}}>
            <div className="card-body py-3">
              <div className="text-center">
                <p className="mb-0" style={{color: '#ffffff', fontSize: '0.9rem'}}>
                  <i className="fas fa-shield-alt me-2"></i>
                  <strong>Financial Management Platform - FMP</strong>
                  <span className="mx-2">|</span>
                  Todos os direitos reservados © 2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjetosPlaceholder;